export default "__VITE_ASSET__Docp$$Gx__"